'use client';
import { useMemo } from 'react';
import dynamic from 'next/dynamic';
import { Spin } from 'antd';
import Image from 'next/image';
import Styles from './contactUs.module.scss';
import { MobileHeaderComp } from 'components';
import logo from 'assets/images/logo.png';
import { __ContactUsItems, __ContactUsLocation } from './contactUs.data';

const ContactUsComp = () => {
    // Leaflet touches `window` on import, so the map is client-only and code-split out of the page bundle.
    const Map = useMemo(
        () =>
            dynamic(() => import('components/locationPicker/locationPicker.index'), {
                loading: () => (
                    <div className="w-100 pv-9 center-content flex-1">
                        <Spin />
                    </div>
                ),
                ssr: false,
            }),
        [],
    );

    const mapURL = `https://maps.google.com/maps?q=${__ContactUsLocation.latitude},${__ContactUsLocation.longitude}`;

    return (
        <>
            <MobileHeaderComp title="تماس با ما" />
            <div className={Styles['contact-us']}>
                <div className={`${Styles['info']} flex-1 flex-column g-3`}>
                    <div>
                        <h1 className="mb-2 t-500 t-h2 d-pre-md-none">تماس با تیک سبز</h1>
                        <Image src={logo} alt="تیک سبز" width={100} height={100} className="d-md-none mb-2" />
                        <p className={`${Styles['item']} t-h3`}>
                            برای ارتباط با ما از راه‌های زیر اقدام کنید. کارشناسان تیک سبز در ساعات کاری پاسخگوی شما
                            هستند.
                        </p>
                    </div>
                    {__ContactUsItems.map((item) => (
                        <div key={item.title} className="d-flex g-2">
                            <div className="pt-1">{item.icon}</div>
                            <div className="flex-1">
                                <h2 className="mb-1 t-500 t-h3 t-l-black1 t-d-gray3">{item.title}</h2>
                                {item.href ? (
                                    <a href={item.href} className={`${Styles['item']} t-p1 t-l-black1 t-d-gray2`}>
                                        {item.value}
                                    </a>
                                ) : (
                                    <p className={`${Styles['item']} t-p1 t-l-black1 t-d-gray2`}>{item.value}</p>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
                <div className="flex-1 flex-column g-2">
                    {/* <h2 className="t-500 t-h3 t-l-black1 t-d-gray3">ما را روی نقشه پیدا کنید</h2> */}
                    <a href={mapURL} target="_blank" className="d-block w-100">
                        <Map
                            latitude={__ContactUsLocation.latitude}
                            longitude={__ContactUsLocation.longitude}
                            className={Styles['map']}
                            attributionControl={false}
                        />
                    </a>
                </div>
            </div>
        </>
    );
};

export default ContactUsComp;
